"use client";
// components/TawkTo.js
// import { useEffect } from "react";

// const TawkTo = () => {
//   useEffect(() => {
//     const tawkToScript = document.createElement("script");
//     tawkToScript.async = true;
//     tawkToScript.src =
//       "https://embed.tawk.to/65f195c19131ed19d9797359/1horr1v7u";
//     tawkToScript.charset = "UTF-8";
//     tawkToScript.setAttribute("crossorigin", "*");

//     document.head.appendChild(tawkToScript);

//     return () => {
//       document.head.removeChild(tawkToScript);
//     };
//   }, []);

//   return null;
// };

// export default TawkTo;

// components/CustomWidget.js
import React, { useEffect } from "react";
import CallIcon from "@/app/images/header/call-icon.svg";
import Image from "next/image";

const TawkTo = () => {
  useEffect(() => {
    // Custom widget setup code can go here if needed
  }, []);

  return (
    <div style={styles.widgetContainer}>
      <div style={styles.widgetContent} className="ccc">
        <a
          href="tel:
+ 1 (888) 346 9886

"
        >
          <Image src={CallIcon} alt="Call Icon" width={64} height={64} />
        </a>
      </div>
    </div>
  );
};

const styles = {
  widgetContainer: {
    position: "fixed",
    bottom: "20px",
    right: "5px",
    zIndex: 1000,
    borderRadius: "10px",
    padding: "10px",
  },
  widgetContent: {
    color: "#333",
    fontSize: "14px",
    fontFamily: "Arial, sans-serif",
  },
  rotatedImage: {
    transform: "rotate(180deg)",
  },
};
export default TawkTo;
